module.exports = __webpack_public_path__ + "static/RootSans-1Thin-21cbe8bf4b0221e374a1ad9455f06db5.woff";